import { Alert } from 'antd';
import React, { Fragment } from 'react';

const Alerts = (props) => {
  return <Fragment></Fragment>;
};

export default Alerts;
